import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const SlideController = ({elements = [], active, onClick}) => (
  <ul className='SellMarketing__controller'>
    {elements.map((item, index) => (
      <li key={index}
        className={cx('SellMarketing__control__circle', {
          'SellMarketing__control__circle--active': active === index
        })}
        onClick={() => onClick(index)}></li>
    ))
    }
  </ul>
);

SlideController.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.shape({
    img: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    name: PropTypes.string,
    alt: PropTypes.string
  })),
  active: PropTypes.number,
  onClick: PropTypes.func
};

export default SlideController;
